import PropTypes from "prop-types"
import { useState } from "react"
import NewActionButton from "~/components/Common/NewActionButton"
import { SRT_LANGUAGES } from "~/constants/languages"
import useSetTranslationMutation from "~/hooks/useSetTranslationMutation"
import DeleteTranslationDialog from "../DeleteTranslation"
import TranslationsHeader from "../TranslationsHeader"

const Translation = ({ translation, updateTranslation, typeData }) => {
  const { type } = typeData
  const openTranslation = (t) => {
    updateTranslation(t)
  }

  const { mutateAsync } = useSetTranslationMutation(typeData)

  const [openDelete, setOpenDelete] = useState(false)

  const deleteTranslation = async () => {
    const data = {
      id: translation.id,
    }
    await mutateAsync(data)
      .then((res) => {
        setOpenDelete(false)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <div
      className="flex items-center bg-[white] my-2 py-2 px-4 rounded-md border border-[#E2E2E2]  hover:bg-[#f5f5f5] cursor-pointer w-full"
      onClick={() => openTranslation(translation)}
    >
      <div className="flex w-[90%] gap-8 items-center">
        <div className="w-1/3">
          {type === "docs" ? translation.doc_name : translation.name}
        </div>
        <div className="w-1/3">
          {type === "docs" ? translation.doc_type : translation.description}
        </div>
        <div className="w-1/3">
          {translation.locale.toUpperCase()} -{" "}
          {SRT_LANGUAGES[translation.locale]}
        </div>
      </div>
      <div className="w-[10%] flex">
        <NewActionButton
          contained={false}
          title="Delete"
          action={(e) => {
            e.stopPropagation()
            setOpenDelete(true)
          }}
          actionType="delete"
        />
      </div>
      <DeleteTranslationDialog
        open={openDelete}
        closeDialog={() => setOpenDelete(false)}
        onDelete={deleteTranslation}
      />
    </div>
  )
}

Translation.propTypes = {
  translation: PropTypes.object,
  updateTranslation: PropTypes.func,
  typeData: PropTypes.object,
}

const TranslationsList = ({
  translations,
  updateTranslation,
  typeData,
  options,
}) => {
  if (translations?.length === 0) return null
  return (
    <div>
      <TranslationsHeader options={options} />
      {translations.map((t) => {
        return (
          <Translation
            key={t.id}
            translation={t}
            updateTranslation={updateTranslation}
            typeData={typeData}
          />
        )
      })}
    </div>
  )
}

TranslationsList.propTypes = {
  translations: PropTypes.array,
  updateTranslation: PropTypes.func,
  typeData: PropTypes.object,
  options: PropTypes.array,
}

export default TranslationsList
